import { useNavigate } from 'react-router-dom';
import { BUTTON_TYPES } from '../../constants/button-variants';
import { world } from '../../languages';
import { AVAILABLE_WORLDS } from '../../languages/constants';
import downloading from '../../utils/downloading';
import isInteractiveStandaloneMaterial from '../../utils/interactive/is-interactive-standalone-material';
import getFreeMaterial from '../../utils/material/download-free-material';
import { isFreeMaterial } from '../../utils/material/material-helper';
import navigateFreeThankYou, { FREE_DOWNLOAD_KINDS } from '../../utils/material/navigate-free-thank-you';
import { hasACL } from '../../utils/price/price-block.helpers';
import DownloadButton from '../download-button/download-button';

type GetFreePropsType = {
    item: Material;
    e?: Event;
    searchRequestId?: string;
    disableScrollToTop?: boolean;
};

const getMaterialForFree = async ({ item, e, searchRequestId, disableScrollToTop }: GetFreePropsType) => {
    // @ts-ignore
    Boolean(e) && downloading(e.currentTarget, item.id);

    await getFreeMaterial(item.id, { materialInfo: item, searchRequestId });

    !disableScrollToTop && window.scrollTo(0, 0);
};

type DownloadControlsProps = {
    material: Material;
    disableScrollToTop?: boolean;
    type?: BUTTON_TYPES;
    searchRequestId?: string;
};

const DownloadControls = (props: DownloadControlsProps) => {
    const { material, disableScrollToTop, type, searchRequestId } = props;
    const navigate = useNavigate();
    const downloadKind = hasACL(material) ? FREE_DOWNLOAD_KINDS.REPEAT : FREE_DOWNLOAD_KINDS.FRESH;

    const handleFreeDownload = async (e?: Event) => {
        if (!isInteractiveStandaloneMaterial(material) && world === AVAILABLE_WORLDS.DE) {
            navigateFreeThankYou({ navigate, materialId: material.id, downloadKind, searchRequestId });
        } else {
            getMaterialForFree({ item: material, e, searchRequestId, disableScrollToTop });
        }
    };

    const isMaterialFree = material.isFree || material.hasAclFree || isFreeMaterial(material);

    return (
        <DownloadButton
            type={type}
            materialId={material.id}
            aclId={material.aclId}
            downloadStatus={isMaterialFree ? 'free' : (material.aclType as string)}
            onDownload={isMaterialFree ? handleFreeDownload : undefined}
        />
    );
};

export default DownloadControls;
